import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: ${tokens.spacing.verticalSmall};
  margin-top: ${tokens.spacing.verticalXlarge};
`

export const ClassesListWrapper = styled.div`
  max-height: 300px;
  overflow: auto;
  margin: ${tokens.spacing.verticalLarge} 0;

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  ::-webkit-scrollbar-thumb {
    background: ${tokens.colors.black2};
  }

  ::-webkit-scrollbar-track {
    background: ${tokens.colors.black1};
  }
`

export const ClassesNotFoundHelper = styled.div`
  display: flex;
  padding: ${tokens.spacing.insetMedium};
  background-color: ${tokens.colors.dark1};
  border-radius: ${tokens.radius.medium};

  font-size: ${tokens.fontSize.small};
  color: ${tokens.colors.dark6};

  cursor: pointer;
`
